import React, { useRef, useCallback, useContext } from "react";
import PT from "prop-types";
import Popover from "_c/Popover";
import * as S from "./styled";
import { Button } from "_c/button";
import { useFocusRestore } from "@/hooks/useFocusRestore";
import { ThemeContext } from "styled-components";

const Markup = (props) => {
  const ref = useRef();
  useFocusRestore(ref);
  return (
    <S.Wrap theme={props.theme} ref={ref} tabIndex="0">
      <S.Title theme={props.theme}>{props.title}</S.Title>
      <S.Buttons theme={props.theme}>
        <Button theme={props.theme} greenish small onClick={props.onAccept}>
          {props.acceptText}
        </Button>
        <Button
          theme={props.theme}
          small
          negative
          onClick={props.onReject}
        >
          {props.rejectText}
        </Button>
      </S.Buttons>
    </S.Wrap>
  );
};
const Confirmable = (props) => {
  const theme = useContext(ThemeContext);
  const ref = useRef();
  const hideTooltip = useCallback(() => {
    if (ref.current) {
      ref.current.hideTooltip();
    }
  }, []);
  const onReject = useCallback(() => {
    if (props.onReject) {
      props.onReject();
    }
    hideTooltip();
  }, [props.onReject]);
  const onAccept = useCallback(() => {
    props.onAccept();
    hideTooltip();
  }, [props.onAccept]);
  return (
    <Popover
      disabled={props.disabled}
      ref={ref}
      content={
        <Markup
          theme={theme}
          title={props.title}
          acceptText={props.acceptText}
          rejectText={props.rejectText}
          onAccept={onAccept}
          onReject={onReject}
        />
      }
    >
      {props.children}
    </Popover>
  );
};
Confirmable.propTypes = {
  title: PT.string.isRequired,
  acceptText: PT.string.isRequired,
  rejectText: PT.string.isRequired,
  onAccept: PT.func.isRequired,
  onReject: PT.func,
};

export default Confirmable;
